import React from "react";
import { Spin } from "antd";

const Loader = () => (
  <div className="loader">
    <Spin size="large" tip="Loading your data Kindly wait" />
  </div>
);

export default Loader;
